import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export const useInstructorPermissions = (instructorId) => {
  const [permissions, setPermissions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!instructorId) {
        setLoading(false);
        return;
      }

      try {
        const permissionRef = doc(db, 'instructorPermissions', instructorId);
        const permissionSnap = await getDoc(permissionRef);
        
        if (permissionSnap.exists()) {
          setPermissions(permissionSnap.data());
        } else {
          // Default permissions for new instructors
          setPermissions({
            skillSheets: 'none',
            scenarioBuilder: 'none',
            specialAssignments: []
          });
        }
      } catch (error) {
        console.error('Error fetching instructor permissions:', error);
        setPermissions({
          skillSheets: 'none',
          scenarioBuilder: 'none',
          specialAssignments: []
        });
      }
      setLoading(false);
    };

    fetchPermissions();
  }, [instructorId]);

  return { permissions, loading };
};
